import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { constructTermsPartial, constructTekstiPartial } from 'utils/constructQuery';
import { RakstsJaunumi } from 'pages';

const withRakstsJaunumiQuery = ({
  terms = ['post_tag'],
  teksti,
  lang,
  orderby = 'date_created',
  order = 'desc'
}) => {
  const QUERY = gql`
    query JaunumiRakstsQuery($lang: String!, $postId: [Int]!, $orderby: [String], $order: [String]) {
      page(lang: $lang, _id: $postId, orderby: $orderby, order: $order,) {
        title
        content
        date_created
        date_modified
        acf
        ${constructTermsPartial(terms, ['slug', 'name'])}
        galerija {
          thumb(size: "large") {
            url
          }
          alt
          caption
        }
      }
      ${constructTekstiPartial(teksti)}
    }
  `;

  const queryOptions = {
    options: ({ lang, postId, init_page, skip }) => {

     // console.log(postId)
     // console.log(init_page)

      return ({
      fetchPolicy: 'cache-first',
      skip: (skip || false),
      variables: {
        lang: (lang || 'lv'),
        orderby: orderby,
        order: order,
        postId: (init_page.rewrite_id ? init_page.rewrite_id : postId),
      }
    })
    },
    props: props => {
      const { data: {
      loading,
        variables: { lang },
        page,
        teksti,
        ...rest
    } } = props;

      return {
        loading,
        data: {
          lang,
          teksti,
          page: (Array.isArray(page) && page.length > 0) ? page[0] : page,
        },
      }
    }
  }

  const JaunumiDefault = (props) => props.loading ? null : (
    <RakstsJaunumi data={props.data} lang={props.lang} path={props.history.location.pathname} />
  );

  return compose(
    graphql(QUERY, queryOptions)
  )(JaunumiDefault);
}

export default withRakstsJaunumiQuery;










// WEBPACK FOOTER //
// ./src/utils/withRakstsJaunumiQuery.js